import AppointmentButton from './AppointmentButton';

export default AppointmentButton;



// WEBPACK FOOTER //
// ./src/components/Pages/Appointments/AppointmentButton/index.js